import React, { useEffect, useState } from 'react';
import { Button, Text, View } from "../../Components/Themed"
import type { BracketCompetitionProps, CompetitionPlayerBracketProps, CompetitionResultTypeProps, MyPlayerProps, PlayerBalanceProps, PlayerBracketProps } from "../../types"
import { Alert, FlatList, Image, Modal } from 'react-native';
import { BracketComeptitionApi, BracketCompetitionHelpers } from '../api';
import JoinCompetitionCard from './JoinCompetitionCard';
import { Icons } from '../../Components';
import { useColors } from '../../constants/useColors';
import SearchBox from '../../Components/SearchBox';

type BracketCompetitionActionProps = {
    bracket_id:string,
    player?:MyPlayerProps,
    view_mode:'mobile'|'desktop',
    height_override?:number,
    competition_id?:string,
    hide_image?:boolean,
    image_width?:number,
    onShowLeaderboard:(pbs:PlayerBracketProps[], cpbs:CompetitionPlayerBracketProps[]) => void,
    onManage:(bracket_competition_id:string) => void,
    onCreateNewCompetition?:(bracket_id?:string) => void,
    insets?:{ top:number, bottom:number, left:number, right:number },
    image_height?:number,
    competition_result_types:CompetitionResultTypeProps[],
    player_balance?:PlayerBalanceProps,
    player_bracket?:PlayerBracketProps,
    onFocusPosition?:(data:{ x:number, y:number, height:number, width:number }) => void,
    player_brackets:PlayerBracketProps[],
    restrict_competition?:boolean,
    competition_player_brackets:CompetitionPlayerBracketProps[],
    onExpand?:() => void,
    onRequestAuthenticate:() => void,
    onSelectCompetition:(bc:BracketCompetitionProps) => void,
    onFoundCompetition:(bc:BracketCompetitionProps) => void,
    onEnterCompetition:(bc:BracketCompetitionProps, cpb:CompetitionPlayerBracketProps, player_bracket?:PlayerBracketProps) => void,
    onLeaveCompetition:(bc:BracketCompetitionProps, cpb:CompetitionPlayerBracketProps) => void
}

const sections = ['active_competition', 'leaderboard', 'actions', 'competitions'];
const BracketCompetitionActions = ({ competition_id, hide_image, image_height, restrict_competition, onShowLeaderboard, onCreateNewCompetition, onManage, image_width, player, player_brackets, insets, onRequestAuthenticate, onSelectCompetition, onFoundCompetition, onFocusPosition, onEnterCompetition, onLeaveCompetition, competition_result_types, player_balance, view_mode, bracket_id, player_bracket, competition_player_brackets }:BracketCompetitionActionProps) => {
    const Colors = useColors();
    const [ search_data, setSearchData ] = useState<{
        visible:boolean,
        value: string,
        error?:string
    }>({
        visible: false,
        value:''
    });
    const [ action_data, setActionData ] = useState<{
        loading: boolean,
        show_enter:boolean,
        show_leaders:boolean,
        active_competition_id?:string,
        bracket_competitions:BracketCompetitionProps[],
    }>({
        loading:false,
        show_leaders: false,
        show_enter:false,
        bracket_competitions:[]
        
    });
    const { show_enter, active_competition_id, bracket_competitions } = action_data;
    const [ action_loading, setActionLoading ] = useState(false);
    let visible_competitions = bracket_competitions.filter(bc => !bc.invite_only).sort((a,b) => parseInt(a.bracket_competition_id) - parseInt(b.bracket_competition_id))
    if(search_data.visible){
        visible_competitions = visible_competitions.filter(c => c.competition_name.toLowerCase().includes(search_data.value.toLowerCase()))
    }
    visible_competitions = visible_competitions//.slice(0,4);
    const active_competition = bracket_competitions.find(bc => bc.bracket_competition_id == active_competition_id);
    const competition_player_bracket = competition_player_brackets.find(cpb => cpb.status != 'deleted' && cpb.player_bracket_id == player_bracket?.player_bracket_id && cpb.bracket_competition_id == active_competition_id);
    const entered_cpbs = competition_player_brackets.filter(cpb => cpb.status != 'deleted' && cpb.bracket_competition_id == active_competition_id);
    const allow_enter = BracketCompetitionHelpers.canEnter(active_competition) && !BracketCompetitionHelpers.isEntered(competition_player_bracket);
    const allow_leave = BracketCompetitionHelpers.canLeave(active_competition) && competition_player_bracket
    const show_entered = competition_player_bracket && !allow_leave ? true : false
    const result_type = competition_result_types.find(r => r.competition_result_type_id == active_competition?.competition_result_type_id);
    useEffect(() => {
        getData(bracket_id, competition_id);
    },[bracket_id, competition_id]);


    const getData = async(id:string, comp_id?:string) => {
        setActionData({ ...action_data, loading:true });
        const bcs = await BracketComeptitionApi.getBracketCompetitionsByBracketId(id);
        
        let active_comp = comp_id
        //if(!active_comp){ 
        //    active_comp = bcs[0]?.bracket_competition_id
        //}
        setActionData({
            ...action_data,
            bracket_competitions: bcs.filter(bc => bc.status != 'pending'),
            active_competition_id: active_comp,
            loading:false
        });
    }

    const handleSearch = async(code:string) => {
        const bc = await BracketComeptitionApi.getBracketcompetitionByCode(code);
        if(!bc){ return setSearchData({ ...search_data, error: 'We could not find a competition with this code.  Please try again' }) }
        setSearchData({ ...search_data, visible: false, error: undefined });
        return onFoundCompetition(bc)
    }

    const handleEnter = async(cpb:CompetitionPlayerBracketProps, player_bracket?:PlayerBracketProps) => {
        if(action_loading){ return }
        if(!player){ return onRequestAuthenticate() }
        if(!active_competition){ return }
        if(active_competition.status != 'scheduled'){ return }
        setActionLoading(true);
        const resp = await BracketComeptitionApi.joinBracketCompetition(cpb);
        onEnterCompetition(resp.bracket_competition, resp.competition_player_bracket, player_bracket);
        setActionData({
            ...action_data,
            show_enter: false,
            bracket_competitions: bracket_competitions.filter(bc => bc.bracket_competition_id != resp.bracket_competition.bracket_competition_id).concat(resp.bracket_competition)
        })
        
        setActionLoading(false);
    }

    const handleLeave = async(cpb_id:string) => {
        if(action_loading){ return }
        if(!player){ return onRequestAuthenticate() }
        setActionLoading(true);
        const resp = await BracketComeptitionApi.leaveBracketCompetition(cpb_id);
        setActionData({
            ...action_data,
            bracket_competitions: bracket_competitions.filter(bc => bc.bracket_competition_id != resp.bracket_competition.bracket_competition_id).concat(resp.bracket_competition)
        })
        onLeaveCompetition(resp.bracket_competition, resp.competition_player_bracket);
        setActionLoading(false);
    }

    const handleSelectCompetition = (bc:BracketCompetitionProps) => {
        onSelectCompetition(bc)
    }
    


    const renderCompetitions = (data:{ item:BracketCompetitionProps, index:number }) => {
        const selected = active_competition_id == data.item.bracket_competition_id ? true : false
        const entered = competition_player_brackets.find(cpb => cpb.status != 'deleted' && cpb.player_bracket_id == player_bracket?.player_bracket_id && cpb.bracket_competition_id == data.item.bracket_competition_id);
        return (
            <Button
                style={{ padding:10, flexDirection:'row', alignItems:'center', borderRadius:0, borderBottomWidth:1, borderBottomColor:Colors.borders.light, backgroundColor:selected?Colors.text.highlight : Colors.views.background }}
                onPress={() => handleSelectCompetition(data.item)}
            >
                <Image
                    source={{ uri: data.item.image?.url }}
                    style={{ height:40, width:40, borderRadius:4 }}
                    resizeMode='cover'
                />
                <View transparent style={{ flex:1, marginLeft:10, marginRight:10 }}>
                    <Text theme='h2'>{data.item.competition_name}</Text>
                    <Text style={{ marginTop:3 }} theme='description'>{data.item.competition_description}</Text>
                </View>
                {entered ?
                <View float style={{ height:30, width:30, borderRadius:100, justifyContent:'center', alignItems:'center' }}>
                    <Icons.CheckIcon color={Colors.text.success} size={14}/>
                </View>
                :<></>}
            </Button>
        )
    }

    const cl = active_competition?.market_type == 'FOR_MONEY' ? '$' : 'E'
    const remaining_tickets = (active_competition?.max_brackets ?? 0) - (active_competition?.tickets_sold ?? 0)
    let payout = BracketCompetitionHelpers.getPayout(active_competition);
    const renderSections = (data:{ item:string, index:number }) => {
        switch(data.item){
            case 'active_competition':
                if(!active_competition){ return <></> }
                return (
                    <View transparent type='body'>
                        {!hide_image ?
                        <Image
                            style={{ height: image_height ?? 300, width: image_width ?? 300, alignSelf:'center' }}
                            source={{ uri: active_competition.image?.url }}
                            resizeMode='cover'
                        />
                        :<></>}
                        <View transparent style={{ padding:20 }}>
                            <View transparent type='row' style={{ marginTop:10 }}>
                                <Text style={{ flex:1 }} theme='h2'>Ticket Price</Text>
                                <Text theme='h1'>{active_competition.buy_in > 0 ? `${cl}${active_competition.buy_in.toFixed(2)}` : 'FREE'}</Text>
                            </View>
                            <View transparent type='row' style={{ marginTop:10 }}>
                                <Text style={{ flex:1 }} theme='h2'>Remaining Tickets</Text>
                                <Text theme='h1'>{remaining_tickets}</Text>
                            </View>
                            {result_type ?
                            <View transparent type='row' style={{ marginTop:10, paddingBottom:10 }}>
                                <Text style={{ flex:1 }} size={14} theme='h1'>Payout Type</Text>
                                <Text size={14} theme='h1' weight='bold'>{result_type.label}</Text>
                            </View>
                            :<></>}
                            {payout > 0 ?
                            <View transparent type='row' style={{ marginTop:10 }}>
                                <Text style={{ flex:1 }} theme='h2'>Payout</Text>
                                <Text theme='h1'>{cl}{payout.toFixed(2)}</Text>
                            </View>
                            :<></>}
                            <View transparent type='row' style={{ marginTop:10 }}>
                                <Text style={{ flex:1 }} theme='h2'>Leaderboard</Text>
                                <Button
                                    transparent
                                    type='action'
                                    style={{ padding:0, justifyContent:'flex-end' }}
                                    onPress={() => onShowLeaderboard(player_brackets, entered_cpbs)}
                                >
                                    <Text theme='h1' color={Colors.text.action} size={14}>View Leaderboard</Text>
                                </Button>
                            </View>
                            {active_competition?.prize_override ?
                            <View float style={{ marginTop:10, padding:5, flexDirection:'row', alignItems:'center', borderRadius:8 }}>
                                <Image
                                    source={{ uri: active_competition.prize_image?.url ?? 'https://res.cloudinary.com/hoabts6mc/image/upload/v1697121009/Medal_and_trophy_awarded_for_success_wkuk6r.png' }}
                                    style={{ height:40, width:40, borderRadius:4 }}
                                    resizeMode='cover'
                                />
                                <View transparent style={{ flex:1, marginLeft:10 }}>
                                    <Text theme='description'>Prize</Text>
                                    <Text theme='h1'>{active_competition.prize_override}</Text>
                                </View>
                            </View>
                            :<></>}
                        </View>
                    </View>
                )
            case 'actions':
                if(!active_competition){ return <></> }
                return (
                    <View style={{ borderTopWidth:1, borderColor:Colors.borders.light }}>
                        {player_bracket ?
                        <View style={{ padding:5 }}>
                            <Text theme='h1' textAlign='center'>{player_bracket.bracket_name}</Text>
                        </View>
                        :<></>}
                        <View transparent style={{ flexDirection:'row',padding:14 }}>
                            {active_competition.admin_id == player?.player_id ?
                            <Button
                                type='action'
                                style={{ flex:1, marginRight:5 }}
                                title='MANAGE'
                                onPress={() => onManage(active_competition.bracket_competition_id)}
                            />
                            :<></>}
                            {allow_enter ?
                            <Button
                                style={{ flex:2, opacity: action_loading? 0.5: 1 }}
                                type='success'
                                loading={action_loading}
                                title='Enter Competition'
                                onPress={() => setActionData({ ...action_data, show_enter: true })}
                            />
                            :<></>}
                            {show_entered && competition_player_bracket ?
                            <Button
                                style={{ flexDirection:'row', alignItems:'center' }}
                                type='action'
                            >
                                <Icons.LockClosedIcon size={14} color={Colors.text.h1} />
                                <Text style={{ marginLeft:4 }}>{competition_player_bracket.place}/{active_competition.tickets_sold}</Text>
                            </Button>
                            :<></>}
                            {allow_leave && competition_player_bracket ?
                            <Button
                                style={{ flex:1, opacity: action_loading? 0.5: 1 }}
                                type='error'
                                loading={action_loading}
                                title='Leave Competition'
                                onPress={() => handleLeave(competition_player_bracket.competition_player_bracket_id)}
                            />
                            :<></>}
                        </View>
                    </View>
                )
            case 'competitions':
                if(restrict_competition){ return <></> }
                return (
                <View transparent>
                    <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:18 }}>
                        <View transparent style={{ flex:1, marginRight:10 }}>
                            <Text theme='h1'>Available Competitions</Text>
                            <Text style={{ marginTop:3 }} theme='description'>Dont see a competition listed? Create a new one or use the search to enter a private code!</Text>
                        </View>
                        {onCreateNewCompetition ?
                        <Button
                            type='success'
                            style={{ flexDirection:'row', alignItems:'center', padding:0, height:35, width:40, justifyContent:'center' }}
                            onPress={() => onCreateNewCompetition(bracket_id)}
                        >
                            <Text theme='h1' color={Colors.text.white}>+</Text>
                            <Icons.TrophyIcon color={Colors.text.white} size={14}/>
                        </Button>
                        :<></>}
                        <Button float style={{ padding:10, marginLeft:5 }} onPress={() => setSearchData({ ...search_data, value:'', visible:!search_data.visible, error: undefined })}>
                            {search_data.visible ?
                            <Icons.CloseIcon size={12} color={Colors.text.error} />
                            :
                            <Icons.SearchIcon size={14} color={Colors.text.h1} />
                            }
                        </Button>
                    </View>
                    {search_data.visible ?
                    <View transparent style={{ margin:4 }}>
                        <SearchBox
                            placeholder='Enter Private Code...'
                            onFocusPosition={onFocusPosition}
                            onSearch={(text) => handleSearch(text)}
                            onChange={(text) => setSearchData({ ...search_data, value: text })}
                        />
                        {search_data.error ?
                        <Text theme='warning' style={{ marginTop:3 }}>{search_data.error}</Text>
                        :<></>}
                    </View>
                    :<></>}
                    <View transparent style={{ marginBottom:10 }}>
                        <FlatList
                            data={visible_competitions}
                            renderItem={renderCompetitions}
                            key={'bracket_competition_options'}
                            keyExtractor={(item) => item.bracket_competition_id.toString()}
                        />
                    </View>
                </View>
                )
            default: return <></>
        }
    }

    return (
        <View transparent style={{ flex:1 }}>
            <FlatList
                key={`comp_actions_list`}
                keyExtractor={(item) => item}
                renderItem={renderSections}
                data={sections}
            />
            <Modal
                visible={show_enter}
                transparent
                animationType={view_mode == 'desktop' ? 'fade' : 'slide'}
                style={{ flex:1 }}
            >
                <View type='blur' style={view_mode == 'desktop' ? { flex:1, justifyContent:'center', alignItems:'center' } : { flex:1, justifyContent:'flex-end', paddingBottom:(insets?.bottom ?? 0) }}>
                    <View style={view_mode == 'desktop' ? { width:500 }: {}}>
                        {active_competition ?
                        <JoinCompetitionCard
                            player={player}
                            bracket_competition={active_competition}
                            player_bracket={player_bracket}
                            player_balance={player_balance}
                            loading={action_loading}
                            onRequestAuthenticate={() => {
                                setActionData({ ...action_data, show_enter: false });
                                setTimeout(() => {
                                    onRequestAuthenticate()
                                }, 500);
                            }}
                            onNotEnoughBalance={() => Alert.alert('Not enough balance')}
                            onEnterCompetition={(cpb, pb) => handleEnter(cpb, pb)}
                            onClose={() => setActionData({ ...action_data, show_enter: false })}
                        />
                        :<></>}
                    </View>
                </View>
            </Modal>
        </View>
    )
}

export default BracketCompetitionActions